// TODO: Replace these utils with the ones from @zenbusiness/application-commons-env package
export const checkIsMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
export const getMobileDeviceType = () =>
  /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
    navigator.userAgent.toLowerCase()
  )
    ? 'tablet'
    : 'mobile';
export const isMobileApp = () => !!navigator.userAgent.toLowerCase().includes('webview');
